import styled from "styled-components";

const DialogButtonDivStyled = styled.div`
  text-align: right;
  /* padding: 10px 15px; */
`;

export default DialogButtonDivStyled;
